import {
    Component,
    ComponentFactoryResolver,
    OnInit,
    ViewChild,
    ViewContainerRef,
    ViewEncapsulation,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ScriptLoaderService } from '../_services/script-loader.service';
import { AuthenticationService } from './_services/authentication.service';
import { AlertService } from './_services/alert.service';
import { UserService } from './_services/user.service';
import { AlertComponent } from './_directives/alert.component';
import { LoginCustom } from './_helpers/login-custom';
import { Helpers } from '../helpers';

@Component({
    selector: '.m-grid.m-grid--hor.m-grid--root.m-page',
    templateUrl: './templates/login-1.component.html',
    encapsulation: ViewEncapsulation.None,
})

export class AuthComponent implements OnInit {
    model: any = {};
    loading = false;
    returnUrl: string;

    @ViewChild('alertSignin',
        { read: ViewContainerRef }) alertSignin: ViewContainerRef;
    @ViewChild('alertSignup',
        { read: ViewContainerRef }) alertSignup: ViewContainerRef;
    @ViewChild('alertForgotPass',
        { read: ViewContainerRef }) alertForgotPass: ViewContainerRef;
    @ViewChild('alertActivate',
        { read: ViewContainerRef }) alertActivate: ViewContainerRef;
    @ViewChild('alertAccount',
        { read: ViewContainerRef }) alertAccount: ViewContainerRef;

    constructor(
        private _router: Router,
        private _script: ScriptLoaderService,
        private _userService: UserService,
        private _route: ActivatedRoute,
        private _authService: AuthenticationService,
        private _alertService: AlertService,
        private cfr: ComponentFactoryResolver) {
    }

    ngOnInit() {



        this._router.routeReuseStrategy.shouldReuseRoute = function() {
            return false;
        };
        this.model.remember = true;

        this.model.accountsearch = false;

        var isAccountSearch = false;


        //CHECK URL for token
        var token = this._route.snapshot.queryParams['token'];
        console.log(token);


        if (token) {
            this.model.activate = true;
            this.model.token = token;

            this._userService.checkToken(this.model.token).subscribe(
                data => {
                    console.log(data);
                    this.model.email = data.data.username;

                },
                error => {
                    console.log(error);
                    this.model.activate = false;
                    this.model.token = "";
                });

        }



        var fragment = this._route.snapshot.fragment;
        console.log("route debugging");
        console.log(fragment);

        if (fragment == "accountsearch") {
            isAccountSearch = true;
            this.model.accountsearch = true;
        }

        // get return url from route parameters or default to '/'
        if (!token && !isAccountSearch) {
            this.returnUrl = this._route.snapshot.queryParams['returnUrl'] || '/';
            this._router.navigate([this.returnUrl]);
        }







        this._script.loadScripts('body', [
            'assets/vendors/base/vendors.bundle.js',
            'assets/demo/demo10/base/scripts.bundle.js'], true).then(() => {
                Helpers.setLoading(false);
                LoginCustom.init();
            });
    }

    signin() {
        this.loading = true;
        this._authService.login(this.model.email, this.model.password).subscribe(
            data => {
                this.showAlert('alertSignin');
                this._alertService.success(
                    'Success',
                    true);

                //window.location.href="dashboard"
                var currentUser = JSON.parse(localStorage.getItem('currentUser'));
                var is_parent_user_account = currentUser.userdata.is_parent_user_account;
                console.log('here');
                console.log(currentUser);

                this.returnUrl = this._route.snapshot.queryParams['returnUrl'] || '/';

                if (is_parent_user_account) {
                    var default_athlete = currentUser.userdata.athletes[0].athlete_id;
                    this.returnUrl = "/parent/dashboard/" + default_athlete;
                }

                if (currentUser.role == "club_admin") {
                    var club_id = currentUser.userdata.club_id_fk;
                    this.returnUrl = "/association/clubs/" + club_id;
                }

                if (currentUser.role == "sportgait_admin") {

                    this.returnUrl = "/sgadmin/dashboard";
                }


                this._router.navigate([this.returnUrl]);
            },
            error => {
                this.showAlert('alertSignin');
                this._alertService.error('Invalid username or password');
                this.loading = false;
            });
    }

    activate() {
        this.loading = true;
        this._authService.activate(this.model.token, this.model.password, this.model.confirm_password).subscribe(
            data => {
                console.log(data);
                /*
                this.showAlert('alertActivate');
                this._alertService.success(
                    'Your account has been activated.',
                    true);
                //this.loading = false;
                //this.loading = true;
                */
                this._authService.login(data.message.username, this.model.password).subscribe(
                    data => {
                        //window.location.href="dashboard"

                        var currentUser = JSON.parse(localStorage.getItem('currentUser'));
                        var is_parent_user_account = currentUser.userdata.is_parent_user_account;
                        console.log('here');
                        console.log(currentUser);

                        this.returnUrl = this._route.snapshot.queryParams['returnUrl'] || '/';

                        if (is_parent_user_account) {
                            var default_athlete = currentUser.userdata.athletes[0].athlete_id;
                            this.returnUrl = "/parent/dashboard/" + default_athlete;
                        }

                        if (currentUser.role == "club_admin") {

                            var club_id = currentUser.userdata.club_id_fk;
                            this.returnUrl = "/association/clubs/" + club_id;
                        }

                        if (currentUser.role == "sportgait_admin") {

                            this.returnUrl = "/sgadmin/dashboard";
                        }


                        this._router.navigate([this.returnUrl]);
                    },
                    error => {
                        this.showAlert('alertActivate');
                        this._alertService.error('Invalid Token. Please use the forgot password link if you have lost your password.');
                        this.loading = false;
                    });
                //this.model = {};
            },
            error => {
                this.showAlert('alertActivate');
                this._alertService.error(error);
                this.loading = false;
            });
    }

    searchAccount() {
        this.loading = true;
        this._authService.searchAccount(this.model.email, this.model.lastname, this.model.dob).subscribe(
            data => {
                console.log(data);
                if (data.reset_token) {
                    this.loading = false;
                    this._router.navigate(["/login"], { queryParams: { token: data.reset_token } });
                } else {
                    this.showAlert('alertAccount');
                    this._alertService.error("There was an Error in activating your account. <br /><br />Please check the information entered for errors. The email address entered needs to be the one used for club communication. <br /><br />If this error continues, please contact customer support at support@sportgait.com");
                    this.loading = false;
                }

            },
            error => {
                this.showAlert('alertAccount');
                this._alertService.error(error);
                this.loading = false;
            });

    }

    signup() {
        this.loading = true;
        this._userService.create(this.model).subscribe(
            data => {
                this.showAlert('alertSignin');
                this._alertService.success(
                    'Thank you. To complete your registration please check your email.',
                    true);
                this.loading = false;
                LoginCustom.displaySignInForm();
                this.model = {};
            },
            error => {
                this.showAlert('alertSignup');
                this._alertService.error(error);
                this.loading = false;
            });
    }

    forgotPass() {
        this.loading = true;
        this._userService.forgotPassword(this.model.email).subscribe(
            data => {
                this.showAlert('alertSignin');
                this._alertService.success(
                    'Password recovery instructions have been sent to your email.',
                    true);
                this.loading = false;
                LoginCustom.displaySignInForm();
                this.model = {};
            },
            error => {
                this.showAlert('alertForgotPass');
                this._alertService.error('This email is not registered');
                this.loading = false;
            });
    }

    createPassword() {
        this.loading = true;
        this._userService.forgotPassword(this.model.email).subscribe(
            data => {
                this.showAlert('alertSignin');
                this._alertService.success(
                    'Password recovery instruction has been sent to your email.',
                    true);
                this.loading = false;
                LoginCustom.displaySignInForm();
                this.model = {};
            },
            error => {
                this.showAlert('alertForgotPass');
                this._alertService.error(error);
                this.loading = false;
            });
    }

    showAlert(target) {
        this[target].clear();
        let factory = this.cfr.resolveComponentFactory(AlertComponent);
        let ref = this[target].createComponent(factory);
        ref.changeDetectorRef.detectChanges();
    }
}


// WEBPACK FOOTER //
// ./src/app/auth/auth.component.ts